import {getState, postState, updateRotationWithActive} from "./state";
import _ from 'lodash';
import moment from "moment";
import {defaultConfig, post} from "./action.service";
import {convertZeroToOne} from "../utils/convertZeroToOne";
import {getCurrentTimestamp} from "../utils/currentTimestamp";
import { Auth } from "aws-amplify";
import axios from "axios";


export async function getRotation() {
    return getState('RedundacySettingsId').then(
        (res: any) => Promise.resolve(createRotation(res))
    )
}

export async function putRotation (data: any, sensors: string[] = []) {
    return updateRotationWithActive(createRotationToPut(data)).then(
        (res) => {
            updateOutputActiveStatus(sensors)
            return res;
        }
    )
}

export const updateOutputActiveStatus = async(sensors: string[]) => {
    const user = await Auth.currentAuthenticatedUser();
    let promises_array:Array<any> = [];
        // sensors.forEach((sensor) => {
        //     promises_array.push(post('/updateNamedDeviceShadow', {
        //         [sensor]: {
        //             'Active': false
        //         }
        //     }, sensor));
        // })
        sensors.forEach((sensor) => {
            promises_array.push(axios.post('/updateNamedDeviceShadow',{
                data: {
                    [sensor]: {
                        'Active': false
                    },
                    sensor
                }
            }, _.assign(defaultConfig, {
                headers: {
                    'Content-Type': 'application/json',
                    'username': user.username
                }
            })));
        })
    return Promise.all(promises_array);
}

const addMinutesAndSeconds = (hours: number, min: number, seconds: number) => {
    return hours*3600 + min*60 + seconds;
}

const createRotationToPut = (data: any) => {
    return {
        'RedundacySettingsId': {
            'Active': _.get(data, 'redundancy', false),
            'TSource': 13,
            'WSett': {
                'NumberOfAirCon': _.get(data, 'numberOfAirConditioners', 0),
                'NumberOfActiveAirCon': _.get(data, 'numberOfActiveAirConditioner', 0),
                'StartTime': convertZeroToOne(addMinutesAndSeconds(moment(_.get(data, 'startRedundancy', 0), 'HH:mm:ss').hour(), moment(_.get(data, 'startRedundancy', 0), 'HH:mm:ss').minutes(), moment(_.get(data, 'startRedundancy', 0), 'HH:mm:ss').second())),
                'CycleTime': convertZeroToOne(addMinutesAndSeconds(moment(_.get(data, 'cycleRedundancy', 0), 'HH:mm:ss').hour(), moment(_.get(data, 'cycleRedundancy', 0), 'HH:mm:ss').minutes(), moment(_.get(data, 'cycleRedundancy', 0), 'HH:mm:ss').second())),
                'UpTempThreash': parseInt(_.get(data, 'upTempThreash', 0), 10),
                'DownTempThreash': parseInt(_.get(data, 'downTempThreash', 0), 10),
                'mAirCon': _.get(data, 'airConditioners', []).map((ac: any) => ac.toString()),
                'TSource': _.get(data, 'sensor', 0) + 6,
            },
            'timestamp': getCurrentTimestamp(),
        }
    }
}


const createRotation = (data: any) => {
    
    const rotation = _.get(data.data, 'state.desired.RedundacySettingsId', _.get(data.data, 'state.reported.RedundacySettingsId', {}));
    if (rotation === {}) {
        return {};
    }
    return {
        redundancy: _.get(rotation, 'Active', false),
        numberOfAirConditioners: _.get(rotation, 'WSett.NumberOfAirCon', 0),
        numberOfActiveAirConditioner: _.get(rotation, 'WSett.NumberOfActiveAirCon', 0),
        startRedundancy: moment.utc(_.get(rotation, 'WSett.StartTime', 0)*1000).format('HH:mm'),
        cycleRedundancy: moment.utc(_.get(rotation, 'WSett.CycleTime', 0)*1000).format('HH:mm'),
        upTempThreash: _.get(rotation, 'WSett.UpTempThreash', 0),
        downTempThreash: _.get(rotation, 'WSett.DownTempThreash', 0),
        sensor: _.get(rotation, 'WSett.TSource', 0) - 6,
        airConditioners: _.get(rotation, 'WSett.mAirCon', []).map((ac: string) => parseInt(ac, 10)),
    }
}